import { addYears, addMonths, addWeeks, addDays, isSameDay as isSameDay$1, isWithinInterval, format, startOfWeek, endOfWeek, eachDayOfInterval, parseISO } from 'date-fns';

const shiftDate = (date, period, amount = 1)=>{
    switch(period){
        case 'day':
            return addDays(date, amount);
        case 'week':
            return addWeeks(date, amount);
        case 'month':
            return addMonths(date, amount);
        case 'year':
            return addYears(date, amount);
    }
};
const isDateBefore = (date1, date2)=>new Date(date1).setHours(0, 0, 0, 0) < new Date(date2).setHours(0, 0, 0, 0)
;
const isSameDay = (date1, date2)=>isSameDay$1(date1, date2)
;
const isWithinTimeSpan = (date, start, end)=>isWithinInterval(date, {
        start,
        end
    })
;
// Date-fns ^2.0.0 doesn't accept string dates anymore.
// Use this fn to make sure your date is either a Date or number
const parseDate = (date)=>typeof date === 'string' ? parseISO(date) : date
;
/**
 * Serialize a Date as a local ISO8601 date string. Like Date.prototype.toISOString,
 * but in the local timezone and just the date, no time or timezone offset.
 */ const toLocalDate = (date)=>format(date, 'yyyy-MM-dd')
;
const toLocalTimeMinutes = (date)=>format(date, 'HH:mm')
;
const getWeekDaysByDate = (date = new Date(), weekStartOffset)=>{
    const start = addDays(startOfWeek(parseDate(date)), weekStartOffset || 0);
    const end = addDays(endOfWeek(parseDate(date)), weekStartOffset || 0);
    return eachDayOfInterval({
        start,
        end
    });
};
const getWeekDaysByDates = (dates, weekStartOffset)=>dates.map((date)=>getWeekDaysByDate(date, weekStartOffset)
    )
;
/**
 * @param weekStartDay accepts values 0-6 which map to Sunday through Saturday
 * Assuming weekStartDay === 2 that sets the start day to Tuesday, however in
 * this case if the day is Sunday or Monday these are in the same week as Tuesday
 * and since this week starts on Tuesday they won't be shown. This function makes
 * sure to account for that and adjust the offset to the week before on the same
 * day as weekStartDay
 * */ const adjustOffsetToAccountForHiddenDays = (date, weekStartDay)=>{
    const isDayThatIsHidden = date.getDay() < weekStartDay;
    const adjustedOffset = (7 - weekStartDay) * -1;
    return isDayThatIsHidden ? adjustedOffset : weekStartDay;
};
const numberOfWeeksToShow = 2;
const firstDayOfWeek = 1 // 0-6, 0 = Sunday, 1 = Monday, etc.
;
const getWeekDaysForWeeksFromDate = (date, weeks = numberOfWeeksToShow, weekStartOffset = firstDayOfWeek)=>{
    const dates = [];
    let i = 0;
    while(i < weeks){
        dates.push(shiftDate(date, 'week', i));
        i++;
    }
    return getWeekDaysByDates(dates, adjustOffsetToAccountForHiddenDays(date, weekStartOffset !== null && weekStartOffset !== void 0 ? weekStartOffset : 0));
};
const getDayLabel = (date, size)=>{
    const days = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday', 
    ];
    return `appointments.${size}Days.${days[date.getDay()]}`;
};

export { adjustOffsetToAccountForHiddenDays, getDayLabel, getWeekDaysByDate, getWeekDaysByDates, getWeekDaysForWeeksFromDate, isDateBefore, isSameDay, isWithinTimeSpan, parseDate, shiftDate, toLocalDate, toLocalTimeMinutes };
//# sourceMappingURL=datetime.js.map
